<template>
  <v-list-item four-line>
    <v-list-item-content class="align-self-start">
      <v-list-item-title
        class="mb-2 font-weight-medium"
        v-text="('WO ' + event.workOrder.workOrderNumber + ' - ' + event.taskNumber)"
      ></v-list-item-title>
      <v-list-item-subtitle v-text="`${event.isd.slice(0,10)}`"></v-list-item-subtitle>
      <v-list-item-subtitle v-text="`${regionNames(event.region)}`"></v-list-item-subtitle>
      <v-list-item-subtitle v-text="event.workOrder.type.name"></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
    },
    methods: {
      regionNames(region) {
        if (region !== null) {
          return region.name
        } else {
          return "Region Not Set"
        }
      }
    }
}
</script>
